export default {"src":"/_next/static/media/facebook.90e5f7a5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};